import Base from '../lib/LdrsBaseElement.js';
import styles from './lineSpinner.scss';
class LineSpinner extends Base {
    _attributes = ['size', 'color', 'speed', 'stroke'];
    size;
    color;
    speed;
    stroke;
    static get observedAttributes() {
        return ['size', 'color', 'speed', 'stroke'];
    }
    constructor() {
        super();
        this.storePropsToUpgrade(this._attributes);
        this.reflect(this._attributes);
    }
    connectedCallback() {
        this.upgradeStoredProps();
        this.applyDefaultProps({
            size: 40,
            color: 'black',
            speed: 1,
            stroke: 3,
        });
        this.template.innerHTML = `
      <div class="container">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
      <style>
        :host{
          --uib-size: ${this.size}px;
          --uib-color: ${this.color};
          --uib-speed: ${this.speed}s;
          --uib-stroke: ${this.stroke}px;
        }
        ${styles}
      </style>
    `;
        this.shadow.replaceChildren(this.template.content.cloneNode(true));
    }
    attributeChangedCallback() {
        const styleEl = this.shadow.querySelector('style');
        if (!styleEl)
            return;
        styleEl.innerHTML = `
      :host{
        --uib-size: ${this.size}px;
        --uib-color: ${this.color};
        --uib-speed: ${this.speed}s;
        --uib-stroke: ${this.stroke}px;
      }
      ${styles}
    `;
    }
}
export default {
    register: (name = 'l-line-spinner') => {
        if (!customElements.get(name)) {
            customElements.define(name, class extends LineSpinner {
            });
        }
    },
    element: LineSpinner,
};
